import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ICertificate } from '@/Module/DefaultLayout/Model';

export const CERTIFICATES: ICertificate[] = [
  {
    width: 70,
    height: 76,
    id: 'footerOne',
    alt: 'footerOne',
    className: 'rounded-xl bg-white p-4',
    referrerPolicy: 'origin',
    src: `${FILE_BROWSER_URL}/img/footerOne.webp`,
  },
  {
    width: 70,
    height: 82,
    id: 'rgvjfukzjxlzapfufukzsizp',
    alt: 'logo-samandehi',
    className: 'rounded-xl bg-white p-4 py-[9.5pt]',
    src: `${FILE_BROWSER_URL}/img/samandehi.webp`,
    referrerPolicy: 'origin',
    onClick: () => {
      window.open(
        'https://logo.samandehi.ir/Verify.aspx?id=361569&p=xlaogvkarfthdshwgvkapfvl',
        'Popup',
        'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30',
      );
    },
  },
  {
    width: 70,
    height: 76,
    id: 'e-namad',
    alt: 'e-namad',
    className: 'rounded-xl bg-white p-4',
    src: `${FILE_BROWSER_URL}/img/Enamad.webp`,
    referrerPolicy: 'origin',
    href: 'https://trustseal.enamad.ir/?id=427187&Code=2rrqLVUtHBWBVB01fZK3baWlNxHzcRpL',
  },
  {
    width: 70,
    height: 76,
    id: 'roshd',
    alt: 'roshd',
    className: 'rounded-xl bg-white p-4',
    src: `${FILE_BROWSER_URL}/img/roshd-logo.webp`,
    referrerPolicy: 'no-referrer',
    href: 'https://static.hamrah.academy/certificate/roshd-certificate.png',
  },
];
